'use strict';
var CheckoutProcessTabsController = /** @class */ (function () {
    /*@ngInject*/
    function CheckoutProcessTabsController(Auth, $state, $scope, $location, CartService) {
        /*cart process tab on mobile*/
        this.checkoutProcessTitle = [
            {
                title: 'My Cart',
                state: 'cart'
            },
            {
                title: 'shipping & delivery',
                state: 'shippingAndDelivery'
            },
            {
                title: 'payment',
                state: 'payment'
            },
            {
                title: 'review order',
                state: 'reviewOrder'
            }
        ];
        this.CartService = CartService;
        this.CartService.readyForReviewOrder = false;
        this.CartService.readyForPayment = false;
        /*cart process tab on mobile*/
        for (var cTitle in this.checkoutProcessTitle) {
            if (this.checkoutProcessTitle[cTitle]['state'] == $state.current.name) {
                this.currentState = this.checkoutProcessTitle[cTitle]['title'];
            }
        }
        this.checkoutProcessTitle = this.currentState;
    }
    CheckoutProcessTabsController.prototype.linkable = function () {
        var status = this.CartService.getLinkStatus();
        return status;
    };
    CheckoutProcessTabsController.prototype.isCartNotEmpty = function () {
        var status = this.CartService.getCartEmptyStatus();
        return status;
    };
    CheckoutProcessTabsController.prototype.readyForPayment = function () {
        var self = this;
        if (this.CartService.readyForPayment) {
            return "1";
        }
        else {
            return "-1";
        }
    };
    CheckoutProcessTabsController.prototype.readyForReviewOrder = function () {
        var self = this;
        if (this.CartService.readyForReviewOrder) {
            return "1";
        }
        else {
            return "-1";
        }
    };
    return CheckoutProcessTabsController;
}());
export default CheckoutProcessTabsController;
//# sourceMappingURL=checkout-process-tabs.controller.js.map